/**
 * DevExtreme (esm/__internal/scheduler/options_validator/index.js)
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export {
    SchedulerOptionsValidator
}
from "./options_validator";
export {
    SchedulerOptionsValidatorErrorsHandler
}
from "./options_validator_errors_handler";
